module.exports = __webpack_public_path__ + "img/Copyright_pic04.9c5fd150.jpg";